import React, { useState } from 'react'
import axios from 'axios';


const AchivementAdder = () => {
    const [formData, setFormData] = useState({
        subject: '',
        Title: '',
        FindURL:'',
        FindAt:''
      });
    
      const [imageFile, setImageFile] = useState(null);
      const [status, setStatus] = useState('');
    
      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: type === 'checkbox' ? checked : value
        }));
      };
    
      const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!imageFile) {
          alert('Please upload an image');
          return;
        }
    
        const reader = new FileReader();
    
        reader.onloadend = async () => {
          const base64Image = reader.result;
    
          const payload = {
            ...formData,
            Image: base64Image // This will be a base64 string (acts as a Blob for backend)
          };
    
          try {
            const response = await fetch('https://portfolio-server-91pj.onrender.com/addAchivement', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer `+localStorage.getItem("Token")
              },
              body: JSON.stringify(payload)
            });
            const result = await response.json();
            setStatus(result.status);
          } catch (error) {
            console.error('Error:', error);
            setStatus('Failed');
          }
        };
    
        reader.readAsDataURL(imageFile); // Converts file to base64
      };
    
      return (
        <div className="project-form">
          <h2>Add Achievement</h2>
          <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Upload Image:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
              style={{color:'white'}}
            />
            </div>

            <div className="form-group">
            <label>Title:</label>
            <input
              type="text"
              name="Title"
              value={formData.Title}
              onChange={handleChange}
              required
            />
            </div>    
    

            <div className="form-group">    
            <label>Subject:</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
            </div>

          
            <div className="form-group">
            <label > FindAt:</label>
            <input
              type="text"
              name="FindAt"
              value={formData.FindAt}
              onChange={handleChange}
            />
            </div>

            <div className="form-group">
            <label > Find URL:</label>
             <input
              type="text"
              name="FindURL"
              value={formData.FindURL}
              onChange={handleChange}
              
            />
            </div>
    
            <button type="submit">Submit</button>
          </form>
          {status && <p className={`status ${status === 'success' ? 'success' : 'failed'}`}>Status: {status}</p>}
        </div>
      );
    };

export default AchivementAdder